import { MarketCodes } from '@prisjakt/web-app-config/types/market';

export enum ReportType {
  WrongPrice = 'price',
  WrongStockStatus = 'stock',
  WrongProduct = 'wrong_product',
}

export type Metadata = {
  message: string;
  ['agent_type_key']: ReportType;
  uri: string;
  ['country_code']: MarketCodes;
  ['store_id']: number;
  ['price_id']: number;
  ['price_value']: string;
  ['stock_status']: string;
};
